/**
 * User Preferences Types
 * Defines user preferences for application settings
 */
/**
 * Page size constraints for operations list pagination
 */
export const PAGE_SIZE_MIN = 5;
export const PAGE_SIZE_MAX = 200;
export const PAGE_SIZE_DEFAULT = 25;
/**
 * Statistics categories count constraints
 */
export const STATISTICS_CATEGORIES_MIN = 3;
export const STATISTICS_CATEGORIES_MAX = 20;
export const STATISTICS_CATEGORIES_DEFAULT = 8;
//# sourceMappingURL=user-preferences.js.map